import { retrieveToken } from '../storage';
import { wrapFetchWithDetailedErrors, apiFetch, apiError } from './api';

// One request helper and one error factory for the iot routes of the panel.
//
// `iot_devices_api` stays out on purpose: its refusals carry the ERR-003 /
// ERR-004 codes in `details`, so it needs an error factory of its own.

const authHeaders = (withBody = false) => {
  const headers = { Authorization: `Bearer ${retrieveToken()}` };
  if (withBody) {
    headers['Content-Type'] = 'application/json';
  }
  return headers;
};

// `apiError` with no overrides is exactly what these routes need: the server's
// own sentence when there is one, the refusal on a 403, the generic bucket
// otherwise. Exported because the callers pass it to `wrapFetch` directly.
export const iotErrorFunction = apiError();

/**
 * wrapFetchWithDetailedErrors on purpose, everywhere: the server refusals carry
 * the readable message the form has to show, and wrapFetch would throw it away.
 */
export const iotRequest = (url, method, body) =>
  wrapFetchWithDetailedErrors(
    apiFetch(url, {
      method,
      headers: authHeaders(body !== undefined),
      withCredentials: true,
      credentials: 'include',
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    }),
    iotErrorFunction,
  );
